import type * as core from '../../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.orgStructureSpace',
    'package:data.higherEd.research.sponsors',
    'resource:data.dimensions.awards',
    'resource:data.dimensions.awards.entities.award',
    'resource:data.dimensions.awards.entities.award.attributes.submissionDate',
    'resource:data.dimensions.awards.entities.award.attributes.sponsor',
    'resource:data.dimensions.awards.entities.award.attributes.space',
    'resource:data.dimensions.awards.entities.award.attributes.organization',
    'resource:data.dimensions.awards.entities.award.attributes.fan',
    'resource:data.dimensions.awards.entities.award.attributes.fain',
    'resource:data.dimensions.awards.entities.award.attributes.budget',
    'resource:data.dimensions.awards.entities.award.attributes.awardDate',
    'resource:data.dimensions.awards.entities.award.attributes.assistanceListing',
    'resource:data.dimensions.awards.entities.award.attributes.researchType',
    'resource:data.dimensions.awardPis',
    'resource:data.dimensions.awardPis.entities.entry',
    'resource:data.dimensions.awardPis.entities.entry.attributes.pi',
    'resource:data.dimensions.awardPis.entities.entry.attributes.award',
    'resource:data.dimensions.assistanceListings',
    'resource:data.dimensions.assistanceListings.entities.listing',
    'resource:data.enums.researchType',
    'resource:data.enums.researchType.entries.other',
    'resource:data.enums.researchType.entries.nonProfitFoundation',
    'resource:data.enums.researchType.entries.internalFunding',
    'resource:data.enums.researchType.entries.federal',
    'resource:data.enums.researchType.entries.externalOther',
    'resource:data.enums.researchType.entries.computational',
    'resource:data.enums.researchType.entries.clinicalTrials',
    'resource:data.enums.researchType.entries.clinicalResearch',
    'resource:data.enums.researchType.entries.benchResearch',
  ],
  description: 'TODO',
  name: 'Research Data - Awards',
} as const satisfies core.quiver.Package
